import { render, staticRenderFns } from "./Invoicing.vue?vue&type=template&id=6bd8aae0&scoped=true&"
import script from "./Invoicing.vue?vue&type=script&lang=js&"
export * from "./Invoicing.vue?vue&type=script&lang=js&"
import style0 from "./Invoicing.vue?vue&type=style&index=0&id=6bd8aae0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd8aae0",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/working_dir/management-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bd8aae0')) {
      api.createRecord('6bd8aae0', component.options)
    } else {
      api.reload('6bd8aae0', component.options)
    }
    module.hot.accept("./Invoicing.vue?vue&type=template&id=6bd8aae0&scoped=true&", function () {
      api.rerender('6bd8aae0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Invoicing.vue"
export default component.exports